exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.box-card[data-v-7679f94c] {\r\n  margin-bottom: 20px;\n}\n.clearfix[data-v-7679f94c] {\r\n  margin-bottom: 10px;\n}\n.role-span[data-v-7679f94c] {\r\n  font-size: 16px;\r\n  font-weight: bold;\n}\r\n", ""]);

// exports
